/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type StatsOperationTagDto = {
    name: string;
    type: StatsOperationTagDto.type;
};

export namespace StatsOperationTagDto {

    export enum type {
        GENERIC = 'GENERIC',
        HIDDEN_DATA_CLASSIFICATION = 'HIDDEN_DATA_CLASSIFICATION',
        VISIBLE_DATA_CLASSIFICATION = 'VISIBLE_DATA_CLASSIFICATION',
        TERM = 'TERM',
        ATLAN_EXTERNAL_TERM = 'ATLAN_EXTERNAL_TERM',
        ALATION_EXTERNAL_TERM = 'ALATION_EXTERNAL_TERM',
        AMUNDSEN_EXTERNAL_TERM = 'AMUNDSEN_EXTERNAL_TERM',
        APACHE_ATLAS_EXTERNAL_TERM = 'APACHE_ATLAS_EXTERNAL_TERM',
        CASTOR_DOC_EXTERNAL_TERM = 'CASTOR_DOC_EXTERNAL_TERM',
        COLLIBRA_EXTERNAL_TERM = 'COLLIBRA_EXTERNAL_TERM',
        DATAGALAXY_EXTERNAL_TERM = 'DATAGALAXY_EXTERNAL_TERM',
        INFORMATICA_EXTERNAL_TERM = 'INFORMATICA_EXTERNAL_TERM',
        SECODA_EXTERNAL_TERM = 'SECODA_EXTERNAL_TERM',
        SELECT_STAR_EXTERNAL_TERM = 'SELECT_STAR_EXTERNAL_TERM',
        GENERIC_CATALOG_EXTERNAL_TERM = 'GENERIC_CATALOG_EXTERNAL_TERM',
        BIGQUERY_EXTERNAL = 'BIGQUERY_EXTERNAL',
        SNOWFLAKE_EXTERNAL = 'SNOWFLAKE_EXTERNAL',
        DATABRICKS_EXTERNAL = 'DATABRICKS_EXTERNAL',
        DBT_EXTERNAL = 'DBT_EXTERNAL',
        ADF_EXTERNAL = 'ADF_EXTERNAL',
        ATLAN_EXTERNAL = 'ATLAN_EXTERNAL',
        ALATION_EXTERNAL = 'ALATION_EXTERNAL',
        AMUNDSEN_EXTERNAL = 'AMUNDSEN_EXTERNAL',
        APACHE_ATLAS_EXTERNAL = 'APACHE_ATLAS_EXTERNAL',
        CASTOR_DOC_EXTERNAL = 'CASTOR_DOC_EXTERNAL',
        COLLIBRA_EXTERNAL = 'COLLIBRA_EXTERNAL',
        DATAGALAXY_EXTERNAL = 'DATAGALAXY_EXTERNAL',
        INFORMATICA_EXTERNAL = 'INFORMATICA_EXTERNAL',
        SECODA_EXTERNAL = 'SECODA_EXTERNAL',
        SELECT_STAR_EXTERNAL = 'SELECT_STAR_EXTERNAL',
        GENERIC_CATALOG_EXTERNAL = 'GENERIC_CATALOG_EXTERNAL',
    }


}
